import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Are you sure you would like to archive selected item? If you continue, the item will no longer be accessible in the system", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { key: 2 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "The selected item cannot be archived because there are some related active items that need to be closed/archived first", -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "No abort the operation", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Yes I would like to continue", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "Abort the operation", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "Save and continue", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "Close", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "Show related items", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_helper_form_error = _resolveComponent("helper-form-error")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_helper_dialog = _resolveComponent("helper-dialog")!

  return (_openBlock(), _createBlock(_component_helper_dialog, {
    width: "500px",
    ref: "helperDialogRef",
    onOpen: _ctx.handleDialogOpen,
    onClose: _ctx.handleReject,
    onClosed: _ctx.handleDialogClosed
  }, {
    header: _withCtx(() => [
      (_ctx.step === _ctx.Step.init)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, "Archiving item"))
        : (_ctx.step === _ctx.Step.decision)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Please provide justification for your decision"))
          : (_openBlock(), _createElementBlock("span", _hoisted_3, "Item cannot be archived"))
    ]),
    footer: _withCtx(({ close }) => [
      (_ctx.step === _ctx.Step.init)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(_ctx.$style.footer)
          }, [
            _createVNode(_component_el_button, {
              text: "",
              type: "primary",
              onClick: close
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_el_button, {
              text: "",
              type: "primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToStep(_ctx.Step.decision)))
            }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            })
          ], 2))
        : (_ctx.step === _ctx.Step.decision)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(_ctx.$style.footer)
            }, [
              _createVNode(_component_el_button, {
                text: "",
                type: "primary",
                onClick: close
              }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                text: "",
                type: "primary",
                onClick: _ctx.handleResolve
              }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              }, 8, ["onClick"])
            ], 2))
          : (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass(_ctx.$style.footer)
            }, [
              _createVNode(_component_el_button, {
                text: "",
                type: "primary",
                onClick: close
              }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                text: "",
                type: "primary",
                onClick: close
              }, {
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 2
              }, 1032, ["onClick"])
            ], 2))
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.content)
      }, [
        (_ctx.step === _ctx.Step.init)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
          : (_ctx.step === _ctx.Step.decision)
            ? (_openBlock(), _createBlock(_component_el_form, {
                key: 1,
                model: _ctx.model,
                rules: _ctx.Rules,
                "require-asterisk-position": "right",
                "label-position": "top",
                ref: "elFormRef"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "I want the item to be archived because ...",
                    prop: "reason"
                  }, {
                    error: _withCtx(({ error }) => [
                      _createVNode(_component_helper_form_error, { error: error }, null, 8, ["error"])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.model.reason,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.reason) = $event)),
                        autosize: { minRows: _ctx.Rows.min, maxRows: _ctx.Rows.max },
                        type: "textarea"
                      }, null, 8, ["modelValue", "autosize"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "rules"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
      ], 2)
    ]),
    _: 1
  }, 8, ["onOpen", "onClose", "onClosed"]))
}